export default __webpack_public_path__ + "static/media/lunarCatMb.e95cfb86.png";